// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flipbook-section {
  padding: 30px 0;
}

.flipbook-wrapper {
  margin-top: 10px;
}

.fb-caption {
  text-align: end;
}

.demoPage img {
  height: 650px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}

.flipbook-section-mob {
  display: none;
}

.flipbook-section {
  display: block;
}

@media (max-width: 767px) {
  .flipbook-wrapper-mob {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .flipbook-section-mob {
    display: block;
  }

  .flipbook-section {
    display: none;
  }

  .flipbook-container {
    margin-top: 70px;
  }

  .demoPage {
    height: 460px !important;
    top: -50px !important;
    left: 0px !important;
    width: 100% !important;
  }

  .demoPage img {
    height: auto;
    width: 90vw;
  }

  .stf__block {
    width: 100vw !important;
    height: auto;
  }

  .flipbook-wrapper {
    min-width: auto !important;
    /* min-height: 430px !important; */
    margin-top: 25%;
  }

  .stf__wrapper {
    padding: 0px !important;
  }
}

/* <div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-1.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-2.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-3.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-4.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-5.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-6.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-7.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-8.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-9.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-10.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-11.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-12.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-13.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-14.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-15.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-16.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-17.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-18.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-19.png\`}
  alt=""
/>
</div>
<div className="demoPage">
<img
  src={\`\${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-20.png\`}
  alt=""
/>
</div> */
`, "",{"version":3,"sources":["webpack://./src/pages/flipbook/FlipBook.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,kCAAkC;IAClC,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;QAuHQ","sourcesContent":[".flipbook-section {\n  padding: 30px 0;\n}\n\n.flipbook-wrapper {\n  margin-top: 10px;\n}\n\n.fb-caption {\n  text-align: end;\n}\n\n.demoPage img {\n  height: 650px;\n  width: fit-content;\n}\n\n.flipbook-section-mob {\n  display: none;\n}\n\n.flipbook-section {\n  display: block;\n}\n\n@media (max-width: 767px) {\n  .flipbook-wrapper-mob {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .flipbook-section-mob {\n    display: block;\n  }\n\n  .flipbook-section {\n    display: none;\n  }\n\n  .flipbook-container {\n    margin-top: 70px;\n  }\n\n  .demoPage {\n    height: 460px !important;\n    top: -50px !important;\n    left: 0px !important;\n    width: 100% !important;\n  }\n\n  .demoPage img {\n    height: auto;\n    width: 90vw;\n  }\n\n  .stf__block {\n    width: 100vw !important;\n    height: auto;\n  }\n\n  .flipbook-wrapper {\n    min-width: auto !important;\n    /* min-height: 430px !important; */\n    margin-top: 25%;\n  }\n\n  .stf__wrapper {\n    padding: 0px !important;\n  }\n}\n\n/* <div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-1.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-2.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-3.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-4.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-5.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-6.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-7.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-8.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-9.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-10.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-11.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-12.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-13.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-14.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-15.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-16.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-17.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-18.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-19.png`}\n  alt=\"\"\n/>\n</div>\n<div className=\"demoPage\">\n<img\n  src={`${process.env.PUBLIC_URL}/images/flipbook-imgs/meritus-ai-20.png`}\n  alt=\"\"\n/>\n</div> */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
